import { IMtaActions, IMtaState } from '../../../../../../../services/mta/models';
import * as React from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as headerActions } from '../../../../../../../services/header/reducer';
import { push } from 'react-router-redux';
import { mtaActions } from '../../../../../../../services/mta/actions';
import { IHeaderActions } from '../../../../../../../services/header/models';
import CancelHeader from '../components/CancelHeader';
import { IAuthState } from '../../../../../../../services/auth/models';
import Loading from '../../../../../../../components/Loading';
import { Button } from 'react-bootstrap';

interface IRenewalDiscountAppliedCompleteProps {
  mta: IMtaState;
  auth: IAuthState;
  dispatch: any;
  history: any;
  actions: {
    header: IHeaderActions;
    push(path: string);
    mta: IMtaActions;
  };
}

class RenewalDiscountAppliedComplete extends React.Component<IRenewalDiscountAppliedCompleteProps, any> {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  private renderSuccessContent = () => {
    const { mta } = this.props;
    const quoteRef = mta.afterSubmit?.quoteReference;
    const premium = mta.afterSubmit?.renewalPremium;
    const isFullDiscount = mta.afterSubmit?.discount?.isFullDiscount || false;
    // const reason = mta.afterSubmit?.reason || '';
    const discount = get(mta, 'afterSubmit.discount.selected.discount', 0.00) - get(mta, 'afterSubmit.discount.previousDiscount', 0.00)
    let discountText = '';

    if (discount) {
      discountText = isFullDiscount ? (discount + '%') : ('an additional ' + discount + '%');
    }

    const handleGoBack = () => {
      const { actions } = this.props;
      actions.push('/account/summary');
    }

    return (
      <div style={{ maxWidth: '800px', margin: '30px auto 0 auto' }}>
        <CancelHeader
          title={`Cancel Renewal Quote ${quoteRef}`}
          showText={false}
          hideCustomerText={true}
          icon={'discount-cancellation'}
        />
        <div className={'white-card'}>
          <p className="mb-25"><b>We're so glad you have chosen to stay with us!</b></p>
          <p><b>Here's {discountText} off your renewal - it's our way of saying thank you.</b></p>
          <p><b>Your new renewal premium is £{premium}.</b></p>
          <p>Remember, you can always come back to the portal if you need to change your policy details, change your
            level
            of cover or get an additional cover.</p>
        </div>
        <div className={'mt-15'}>
          <Button
            type="button"
            className="secondary-button medium-width"
            onClick={handleGoBack}>
            RETURN TO POLICY
          </Button>
        </div>
      </div>
    );
  }

  private renderFailedContent = () => {
    return (
      <div>
        <h2>There has been a problem</h2>
        <p className="mb-25">
          Unfortunately there has been a problem applying a discount on your renewal , please see
          our <a className="pointer" href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>Contact
          Us</a> page for
          details on how to get in touch.
        </p>
      </div>
    );
  }

  public render() {
    const { mta } = this.props;

    if (mta.isLoading) {
      return (
        <Loading/>
      )
    }

    if (mta.afterSubmit.success && mta.afterSubmit.changes !== 0) {
      return this.renderSuccessContent();
    } else {
      return this.renderFailedContent();
    }
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      mta: state.mta,
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        header: bindActionCreators({ ...headerActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(RenewalDiscountAppliedComplete);
